// =============================================================================
// _validation.ts — shared input-validation helpers for all service modules
// =============================================================================

/**
 * Throws RangeError if `v` is not a finite integer.
 * Matches Unity's implicit int type constraints.
 */
export function assertFiniteInt(v: number, label: string): void {
  if (!Number.isFinite(v)) {
    throw new RangeError(`${label}: must be finite, got ${String(v)}`);
  }
  if (!Number.isInteger(v)) {
    throw new RangeError(`${label}: must be integer, got ${v}`);
  }
}
